export default "__VITE_ASSET__DcsPa9yb__"